import React, { ComponentType } from 'react'
import authorization, { LIVE_PERMISSIONS } from 'live/services/authorization'

export function isJSON(value: string): boolean {
    try {
        JSON.parse(value)
        return true
    } catch (e) {
        return false
    }
}

export function themeAwardWidgetDecorator<P>(Component: ComponentType<P>): ComponentType<P> {
    return function ThemeAwareTree(props: P): JSX.Element {
        return React.createElement(React.Fragment, null, React.createElement(Component, { ...props }))
    }
}

export const normalizeBaseHash = (baseHash: string): string => {
    if (!baseHash) return '#/'

    let normalized = baseHash.trim()
    if (!normalized) return '#/'

    // Remove leading '/#/' or '#/' or '#'
    normalized = normalized.replace(/^\/?#\/?/, '')

    // Add '#/' prefix
    return '#/' + normalized
}

export function userCanSeeTheWidget(): boolean {
    return (
        authorization.Permission[LIVE_PERMISSIONS.ADMIN] ||
        authorization.Permission[LIVE_PERMISSIONS.MANAGE_PIPES_WIDGETS]
    )
}
